// src/utils/layoutShell.js
import { APP_SHELL_LAYOUT } from "../constants/constants";

export function getMainScrollContainer() {
  if (typeof document === "undefined") return null;
  return document.getElementById("main-layout-scroll-container");
}

export function scrollMainContainerToTop() {
  const el = getMainScrollContainer();
  if (el) {
    el.scrollTop = 0;
    el.scrollLeft = 0;
    return;
  }
  if (typeof window !== "undefined") {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }
}

export function getMainLayoutStickyTopOffsetCss(extraPx = 0) {
  if (!extraPx) return APP_SHELL_LAYOUT.TOP_APP_BAR_OFFSET_CSS;
  return `calc(${APP_SHELL_LAYOUT.TOP_APP_BAR_OFFSET_CSS} + ${extraPx}px)`;
}

